import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll(".accordion");

    const openAcc = (acc) => {
        const content = acc.querySelector(".accordion__content");
        const icon = acc.querySelector(".accordion__head__btn img");

        if (!content || acc.dataset.open === "true") return;

        gsap.killTweensOf(content);

        gsap.set(content, { height: "auto", opacity: 1 });
        const fullHeight = content.offsetHeight;

        gsap.fromTo(
            content,
            { height: 0, opacity: 0, overflow: "hidden" },
            {
                height: fullHeight,
                opacity: 1,
                duration: 0.45,
                ease: "back.out(1.3)",
                onComplete: () => {
                    gsap.set(content, { height: "auto", overflow: "visible" });
                    acc.dataset.open = "true";
                }
            }
        );

        if (icon) gsap.to(icon, { rotate: 45, duration: 0.25 });
    };

    const closeAcc = (acc) => {
        const content = acc.querySelector(".accordion__content");
        const icon = acc.querySelector(".accordion__head__btn img");

        if (!content || acc.dataset.open !== "true") return;

        const currentHeight = content.offsetHeight;

        gsap.killTweensOf(content);

        gsap.fromTo(
            content,
            { height: currentHeight, opacity: 1, overflow: "hidden" },
            {
                height: 0,
                opacity: 0,
                duration: 0.35,
                ease: "power2.inOut",
                onComplete: () => {
                    gsap.set(content, { height: 0, opacity: 0 });
                    acc.dataset.open = "false";
                }
            }
        );

        if (icon) gsap.to(icon, { rotate: 0, duration: 0.25 });
    };

    accordions.forEach((acc) => {
        const head = acc.querySelector(".accordion__head");
        const content = acc.querySelector(".accordion__content");

        if (!head || !content) return;

        // Init: closed state
        gsap.set(content, { height: 0, opacity: 0, overflow: "hidden" });
        acc.dataset.open = "false";

        acc.addEventListener("click", () => {
            // close others
            accordions.forEach((other) => {
                if (other !== acc) closeAcc(other);
            });

            // toggle
            if (acc.dataset.open === "true") {
                closeAcc(acc);
            } else {
                openAcc(acc);
            }
        });
    });
});
